(function () {
    function initBlogSliders() {
        if (typeof window.Swiper !== 'function') return;

        document.querySelectorAll('[data-blog-slider]').forEach(function (slider) {
            if (slider.swiper) return;

            const swiper = new window.Swiper(slider, {
                slidesPerView: 1.03,
                spaceBetween: 12,
                speed: 500,
                watchOverflow: true,
                keyboard: {
                    enabled: true,
                },
                pagination: {
                    el: slider.closest('.blog-section').querySelector('.blog-section__pagination'),
                    clickable: true,
                },
                navigation: {
                    prevEl: slider.closest('.blog-section').querySelector('.blog-section__arrow--prev'),
                    nextEl: slider.closest('.blog-section').querySelector('.blog-section__arrow--next'),
                },
                breakpoints: {
                    769: {
                        slidesPerView: 2.1,
                    },
                    1200: {
                        slidesPerView: 3.2,
                    },
                },
            });

            swiper.wrapperEl.style.transitionTimingFunction = 'cubic-bezier(0.22, 1, 0.36, 1)';
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initBlogSliders);
    } else {
        initBlogSliders();
    }
})();
